import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'

type Data = {
  proposalId: string
}

export const sendToReview = async (data: Data): Promise<any> => {
  return axios.post(`/orders/proposals/${data.proposalId}/send-to-review`, data)
}

export function useSendToReview() {
  const queryClient = useQueryClient()
  return useMutation(sendToReview, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('orderActions')
      toast.success('Orçamento enviado para análise!')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível enviar o orçamento para a análise!')
    }
  })
}
